import { FC } from 'react'
import { BaseTheme } from '../theme/BaseTheme'

// Need to use this version of ThemeProvider to support makeStyles
import { StylesProvider, ThemeProvider as ThemeProvider2 } from '@mui/styles'

import { ThemeProvider } from '@mui/material'
import { generateMui5ClassName } from '../utils/jssClassNameGenerators'

// Wrapper on <ThemeProvider> for opensolar-ui
// At some point this will handle theme switching
export const ThemeContext: FC<{ children }> = ({ children }) => {
  const theme = BaseTheme
  return (
    <ThemeProvider theme={theme}>
      <StylesProvider generateClassName={generateMui5ClassName}>
        <ThemeProvider2 theme={theme}>{children}</ThemeProvider2>
      </StylesProvider>
    </ThemeProvider>
  )
}
